export const formSchema = {
	type: "object",
	required: [
		"type",
		"name",
		"registration_number",
		"registration_state",
		"company",
		"model",
		"year",
		"color"
	],
	properties: {
		type: {
			type: "string",
			title: "Type",
			enum: [
				'Trailer',
				'Van',
				'Ute',
				'Car',
				'Motorcycle',
				'Truck',
				'Roller',
				'Excavator',
				'Skidsteer',
				'Dumper',
				'Ride-on Mower',
				'Other'
			]
		},
		name: {
			type: "string",
			title: "Name",
			maxLength: 256
		},
		registration_number: {
			type: "string",
			title: "Registration Number",
			maxLength: 10
		},
		registration_state: {
			type: "string",
			title: "Registration State",
			enum: [
				"New South Wales",
				"Queensland",
				"South Australia",
				"Tasmania",
				"Victoria",
				"Western Australia",
				"Australian Capital Territory",
				"Northern Territory",
				"New Zealand"
			]
		},
		company: {
			type: "string",
			title: "Make",
			maxLength: 100
		},
		model: {
			type: "string",
			title: "Model",
			maxLength: 50
		},
		year: {
			type: "number",
			title: "Year",
			maxLength: 4,
			default: 20
		},
		color: {
			type: "string",
			title: "Color",
			maxLength: 50
		},
		odometer: {
			type: "number",
			title: "Current Odometer (Kms)"
		},
		last_serviced: {
			type: "number",
			title: "Last Serviced (Kms)"
		},
		canbus: {
			type: "boolean",
			title: "Can Bus Installed?",
			default: false
		},
		temp_probe: {
			type: "boolean",
			title: "Temperature Probe Installed?",
			default: false
		},
		fuelcapacity: {
			type: "number",
			title: "Fuel Tank Capacity (L)",
			default: 0
		},
	}
};

export const uiSchema = {
	type: {
		"ui:autofocus": true,
	},
	year: {
		"ui:widget": "updown",
	}
};
